/**
 * Warehouse detail route — thin shim mounting `<WarehouseDetailPage />`.
 *
 * @see apps/web/src/features/inventory/warehouses/warehouse-detail-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { WarehouseDetailPage } from "../../../../features/inventory/warehouses/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/warehouses/$warehouseId/")({
  component: WarehouseDetailRoute,
});

function WarehouseDetailRoute() {
  const { warehouseId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Warehouses", to: "/inventory/warehouses" },
        { label: "Detail" },
      ]}
      disableViewportScroll
      contentClassName="max-w-none h-full"
    >
      <WarehouseDetailPage warehouseId={warehouseId} />
    </WorkspaceShell>
  );
}
